export default {
  rid: 478,
  loanTypeOptions: [
    'Auto Loan',
    'Commercial Real Estate Loan',
    'Credit Card',
    'Equipment Loan',
    'Flooring Line',
    'Line of Credit',
    'Merchant Cash Advance',
    'Other Debt',
    'Private Loan',
    'SBA Loan',
    'Shareholder Loan',
    'Term Loan'
  ],
  outstandingLoans: [
    {
      rid: 3,
      active: true,
      refinance: true,
      lender: 'lender',
      creLoan: false,
      debtType: 'Term Loan',
      monthsRemaining: 15,
      principalBalance: 304040,
      originationDate: 1391241600,
      maturityDate: null,
      monthlyPayment: 4300,
      minimumPayment: 1,
      paymentFrequency: 'daily',
      __typename: 'OutstandingLoan'
    }
  ],
  __typename: 'Business'
}